module.exports = __webpack_public_path__ + "img/xcbm-title.1d86a0fb.png";